// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Components
import './components'

// Plugins
import './plugins'
import { auth } from '@/plugins/firebase'
import { sync } from 'vuex-router-sync'

// Application imports
import App from './App'
import router from '@/router'
import store from '@/store'
import vuetify from './plugins/vuetify'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import VueCkeditor from 'vue-ckeditor5'
import Vue2Filters from 'vue2-filters'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: { id: 'UA-154476229-1' }
}, router)

Vue.use(Vue2Filters)
Vue.use(Viewer)

const options = {
  editors: {
    classic: ClassicEditor
  },
  name: 'ckeditor'
}

Vue.use(VueCkeditor.plugin, options)

// Sync store with router
sync(store, router)

Vue.config.productionTip = false

auth.onAuthStateChanged(user => {
  store.dispatch('fetchUser', user)
})

/* eslint-disable no-new */
new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
